import { AnimatedSvgIds, TestIds } from './constants';

export const addAttributesToStringSvg = (
  svgContent: string,
  duration: number,
) => {
  return svgContent
    .replace(
      new RegExp(
        `(<svg[^>]*data-animate-id=["']${AnimatedSvgIds.animatedSvg}["'])`,
        'g',
      ),
      `$1 data-testid="${TestIds.animatedSvg}"`,
    )
    .replace(
      new RegExp(
        `(<animate[^>]*data-animate-id=["']${AnimatedSvgIds.animateTagForward}["'])`,
        'g',
      ),
      `$1 dur="${duration}s" data-testid="${TestIds.animateTagForward}"`,
    )
    .replace(
      new RegExp(
        `(<animate[^>]*data-animate-id=["']${AnimatedSvgIds.animateTagBackward}["'])`,
        'g',
      ),
      `$1 dur="${duration}s" data-testid="${TestIds.animateTagBackward}"`,
    );
};
